import { render } from "./ChannelCom.vue?vue&type=template&id=41bb6e04&scoped=true"
import script from "./ChannelCom.vue?vue&type=script&lang=js"
export * from "./ChannelCom.vue?vue&type=script&lang=js"

import "./ChannelCom.vue?vue&type=style&index=0&id=41bb6e04&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bb6e04"]])

export default __exports__